import { Fragment } from "react";
import { RiLockPasswordFill } from "react-icons/ri"
import { HiPencil } from "react-icons/hi"
import { HiBars3CenterLeft, HiArrowLeftOnRectangle } from "react-icons/hi2"
import { Menu, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";

export default function TopBar({ showNav, setShowNav, userName }) {

    return (
        <div
            className={`bg-white z-10 fixed w-full h-16 flex justify-between items-center transition-all duration-[400ms] ${showNav ? "pl-56" : ""
                }`}
        >
            <div className="pl-4 md:pl-16">
                <HiBars3CenterLeft
                    className="h-8 w-8 text-gray-700 cursor-pointer"
                    onClick={() => setShowNav(!showNav)}
                />
            </div>
            <div className="flex items-center pr-4 md:pr-16">
                <Menu as="div" className="relative inline-block text-left">
                    <div>
                        <Menu.Button className="inline-flex w-full justify-center items-center">
                            <picture>
                                <img
                                    src={`https://api.dicebear.com/5.x/initials/svg?seed=${userName}`}
                                    className="rounded-full h-10 shadow-sm"
                                    alt="profile picture"
                                />
                            </picture>
                        </Menu.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform scale-95"
                        enterTo="transform scale-100"
                        leave="transition ease-in duration=75"
                        leaveFrom="transform scale-100"
                        leaveTo="transform scale-95"
                    >
                        <Menu.Items className="absolute right-0 w-56 z-50 mt-2 origin-top-right bg-white rounded shadow-sm">
                            <div className="p-1">
                                <Menu.Item>
                                    <Link
                                        to={`/dashboard/user/${userName}/profile`}
                                        className="flex hover:bg-orange-500 hover:text-white text-gray-700 rounded p-2 text-sm group transition-colors items-center"
                                    >
                                        <HiPencil className="h-4 w-4 mr-2" />
                                        Edit Profile
                                    </Link>
                                </Menu.Item>
                                <Menu.Item>
                                    <Link
                                        to={`/dashboard/user/${userName}/profile/change-password`}
                                        className="flex hover:bg-orange-500 hover:text-white text-gray-700 rounded p-2 text-sm group transition-colors items-center"
                                    >
                                        <RiLockPasswordFill className="h-4 w-4 mr-2" />
                                        Change Password
                                    </Link>
                                </Menu.Item>
                                <Menu.Item>
                                    <div
                                        className="flex hover:bg-orange-500 hover:text-white text-gray-700 rounded p-2 text-sm group transition-colors items-center cursor-pointer"
                                        onClick={() => {
                                            alert("logout")
                                        }}
                                    >
                                        <HiArrowLeftOnRectangle className="h-5 w-4 mr-2" />
                                        Logout
                                    </div>
                                </Menu.Item>
                            </div>
                        </Menu.Items>
                    </Transition>
                </Menu>
            </div>
        </div>
    );
}
